/** Text logo «PHAGE ENERGY», as in the prototype, until the SVG exists. */
import { Link } from 'react-router-dom';

import { useT } from '../i18n/locale-context.js';

export function Logo({ to }: { to?: string }) {
  const t = useT();
  const body = (
    <>
      <span className="w1" aria-hidden="true">
        PHAGE
      </span>
      <span className="w2" aria-hidden="true">
        ENERGY
      </span>
    </>
  );
  return to ? (
    <Link className="logo" to={to} aria-label={t('app.brand')}>
      {body}
    </Link>
  ) : (
    <div className="logo" role="img" aria-label={t('app.brand')}>
      {body}
    </div>
  );
}
